import { useContext } from 'react';
import AuthContext from '@contexts/AuthContext';

// ============================================================
// useAuth
// Convenience hook — import this everywhere instead of
// importing both useContext and AuthContext separately
// ============================================================

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error(
      'useAuth must be used inside <AuthProvider>. ' +
      'Make sure your component is wrapped in App.jsx.'
    );
  }

  return context;
};

export default useAuth;
